/** Stable public pathway identifiers for School / University QR (no PII in URLs). */
export const SCHOOL_UNIVERSITY_PROGRAMME_ID = "programme-school-university";
export const SCHOOL_UNIVERSITY_PATH = "/pathways/school-university";

export function authLinksForSchoolUniversityPathway() {
  return {
    register: "/register",
    login: "/login",
    forgotPassword: "/forgot-password",
    privacy: "/privacy",
    terms: "/terms",
  };
}
